import React from 'react';
import {TouchableOpacity, ViewStyle} from 'react-native';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export type PillButtonVariant = 'outline' | 'primary' | 'danger' | 'gold';

// Rounded pill action button used in ChessModal footers - outlined cream
// Cancel, filled teal for constructive actions, filled red (with a soft
// glow) for destructive ones, filled gold for brand-primary CTAs. Extracted
// so modal footers stop hand-rolling these styles.
function PillButton({
  label,
  variant = 'primary',
  icon,
  onPress,
  disabled,
  style,
}: {
  label: string;
  variant?: PillButtonVariant;
  icon?: string;
  onPress: () => void;
  disabled?: boolean;
  style?: ViewStyle;
}) {
  const fill =
    variant === 'primary'
      ? '#3DAB9E'
      : variant === 'danger'
      ? '#EF4444'
      : variant === 'gold'
      ? '#FACF47'
      : '#FFFFFF';
  const textColor =
    variant === 'outline'
      ? '#262322'
      : variant === 'gold'
      ? '#4D3F37'
      : '#FFFFFF';
  return (
    <TouchableOpacity
      disabled={disabled}
      onPress={onPress}
      style={[
        {
          paddingVertical: 9,
          paddingHorizontal: 22,
          borderRadius: 100,
          backgroundColor: fill,
          alignItems: 'center',
          justifyContent: 'center',
          opacity: disabled ? 0.5 : 1,
        },
        variant === 'outline' && {
          borderWidth: 1.5,
          borderColor: 'rgba(77,63,55,0.18)',
        },
        (variant === 'danger' || variant === 'primary') &&
          !disabled && {
            shadowColor: fill,
            shadowOffset: {width: 0, height: 4},
            shadowOpacity: 0.3,
            shadowRadius: 10,
            elevation: 4,
          },
        style,
      ]}>
      <Box type="row-center" style={{gap: 7}}>
        {!!icon && (
          <MaterialCommunityIcons name={icon} size={14} color={textColor} />
        )}
        <CCText fontSize={13} fontWeight="semibold" color={textColor}>
          {label}
        </CCText>
      </Box>
    </TouchableOpacity>
  );
}

export default PillButton;
